import styled from "styled-components";

export const GenerateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 80px 0;
`;

export const GenerateContainer = styled.div`
  display: flex;
  max-width: 1200px;
  width: 95%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  img {
    width: 100%;
    height: auto;
  }
`;

export const GenerateContent = styled.div`
  span {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #e11d48;
    cursor: pointer;
  }
  h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 64px;
    color: #fff;
  }
`;
